import { IHttpApi } from '@cian/http-api/';

import { ResponseError } from '../../errors';
import {
  fetchGetBannerEnrichments,
  IGetBannerEnrichmentsRequest,
  IGetBannerEnrichmentsResponse200,
  IGetBannerEnrichmentsResponse400,
} from '../../repositories/ad-banner/v1/get-banner-enrichments';

interface IParams {
  httpApi: IHttpApi;
  parameters: IGetBannerEnrichmentsRequest;
}
export async function getNewbuildingInfoForTgb({ httpApi, parameters }: IParams) {
  const result = await fetchGetBannerEnrichments<IGetBannerEnrichmentsResponse200, IGetBannerEnrichmentsResponse400>({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'getNewbuildingInfoForTgb',
      message: result.response.message || 'Неизвестная ошибка загрузки информации по баннеру',
    });
  }

  return result.response;
}
